import { render, staticRenderFns } from "./AssistRank.vue?vue&type=template&id=b44c3148&scoped=true&"
import script from "./AssistRank.vue?vue&type=script&lang=js&"
export * from "./AssistRank.vue?vue&type=script&lang=js&"
import style0 from "./AssistRank.vue?vue&type=style&index=0&id=b44c3148&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44c3148",
  null
  
)

export default component.exports